const CookieControl = () => {
    // Function to create and insert spans into cookie control buttons so we can correctly use gradient bg hover
    document.addEventListener('DOMContentLoaded', function() {

        // Wait 200ms after the DOM is loaded before executing the code.
        setTimeout(function() {
          // Select the "Accept all" button by its ID
          var acceptBtn = document.getElementById('s-all-bn');
          if (acceptBtn) {
            var acceptSpan = document.createElement('span');
            acceptSpan.textContent = acceptBtn.textContent;
            acceptBtn.textContent = '';
            acceptBtn.appendChild(acceptSpan);
          }
        
          // Select the "Reject all" button by its ID
          var rejectBtn = document.getElementById('s-rall-bn');
          if (rejectBtn) {
            var rejectSpan = document.createElement('span');
            rejectSpan.textContent = rejectBtn.textContent;
            rejectBtn.textContent = '';
            rejectBtn.appendChild(rejectSpan);
          }
          
          // Select the "Save" button by its ID
          var saveBtn = document.getElementById('s-sv-bn');
          if (saveBtn) {
            var rejectSpan = document.createElement('span');
            rejectSpan.textContent = saveBtn.textContent;
            saveBtn.textContent = '';
            saveBtn.appendChild(rejectSpan);
          }
      
        }, 2000); // 2000ms delay
      });
};

export default CookieControl;